(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["skin-shared-styles"] && !Shopify.designMode) return;
  try {
    (function () {
    'use strict';
    if (window.__drySkinSectionsInitialized) return;
    window.__drySkinSectionsInitialized = true;

    const observerOptions = {
      root: null,
      rootMargin: '0px 0px -100px 0px',
      threshold: 0.15,
    };

    const observer = new IntersectionObserver(function (entries) {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animate-in');
        } else {
          entry.target.classList.remove('animate-in');
        }
      });
    }, observerOptions);

    const contentSections = document.querySelectorAll('.details-content-section');
    const productSections = document.querySelectorAll('.details-product-section');

    contentSections.forEach((section) => observer.observe(section));
    productSections.forEach((section) => observer.observe(section));

    let ticking = false;
    function updateOnScroll() {
      ticking = false;
    }

    window.addEventListener(
      'scroll',
      function () {
        if (!ticking) {
          window.requestAnimationFrame(updateOnScroll);
          ticking = true;
        }
      },
      { passive: true }
    );

    contentSections.forEach((section) => {
      section.style.willChange = 'transform, opacity';
    });
    productSections.forEach((section) => {
      section.style.willChange = 'transform, opacity';
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
